<template>
  <van-image
    :class="[classOption, { 'screen-img-ready': hasDisplayedImage }]"
    :src="displaySrc"
    :show-loading="showPlaceholder"
    :show-error="showPlaceholder"
    @load="onLoaded"
    @error="onError"
  >
    <template v-slot:loading>
      <img src="../assets/home/banner_loading.jpg" draggable="false" alt="" />
    </template>
    <template v-slot:error>
      <img src="../assets/home/banner_loading.jpg" draggable="false" alt="" />
    </template>
  </van-image>
</template>

<script>
let listenerCount = 0;
let boundHandler = null;

function preventDrag(e) {
  const target = e.target;
  if (target.matches(".van-image__img")) {
    e.preventDefault();
  }
}

function addGlobalDragPrevent() {
  if (listenerCount === 0) {
    boundHandler = preventDrag;
    document.addEventListener("mousedown", boundHandler);
  }
  listenerCount++;
}

function removeGlobalDragPrevent() {
  listenerCount--;
  if (listenerCount <= 0) {
    listenerCount = 0;
    if (boundHandler) {
      document.removeEventListener("mousedown", boundHandler);
      boundHandler = null;
    }
  }
}

export default {
  name: "screen-img",
  props: {
    classOption: String,
    src: String,
  },
  data() {
    return {
      displaySrc: "",
      hasDisplayedImage: false,
      preloadToken: 0,
    };
  },
  computed: {
    showPlaceholder() {
      return !this.hasDisplayedImage;
    },
  },
  watch: {
    src: {
      immediate: true,
      handler(newSrc) {
        this.applySrc(newSrc);
      },
    },
  },
  mounted() {
    addGlobalDragPrevent();
  },
  beforeDestroy() {
    this.preloadToken += 1;
    removeGlobalDragPrevent();
  },
  methods: {
    applySrc(newSrc) {
      if (!newSrc) {
        this.preloadToken += 1;
        this.displaySrc = "";
        this.hasDisplayedImage = false;
        return;
      }
      if (!this.displaySrc) {
        this.displaySrc = newSrc;
        return;
      }
      if (newSrc === this.displaySrc) {
        return;
      }
      const token = ++this.preloadToken;
      const img = new Image();
      img.onload = () => {
        if (token !== this.preloadToken || this.src !== newSrc) {
          return;
        }
        this.displaySrc = newSrc;
        this.hasDisplayedImage = true;
      };
      img.onerror = () => {
        if (token !== this.preloadToken) {
          return;
        }
      };
      img.src = newSrc;
    },
    onLoaded() {
      this.hasDisplayedImage = true;
      this.$emit("Loaded", true);
    },
    onError() {
      if (!this.hasDisplayedImage) {
        this.$emit("Errored", true);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.van-image {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: inherit;
}

:deep(.van-image__img),
:deep(.van-image__loading),
:deep(.van-image__error) {
  border-radius: inherit;
}

.screen-img-ready {
  :deep(.van-image__img) {
    transition: opacity 0.18s ease;
  }
}
</style>
